import htttp from "../../../helpers/axios";
import { HomeData } from "../../../api";

// state is where all the data are at, all the values.
const state = {
  HomeData: []
};
// getters is there to get value from state or get filtered value from state
const getters = {
  HomeData: state => state.HomeData
};
//  mutations is there to update the state. here Homedata in state is assigned the value of payload
const mutations = {
  saveHomeData(state, payload) {
    state.HomeData = payload;
  }
};
// actions is there to call mutations. and the data( data.data ) given to in action in commit goes as payload to mutations
const actions = {
  GET_HOMEDATA: async ({ commit }) => {
    // console.log(
    //   "STEP: 3 - The action call comes to store actions from navigationbar."
    // );
    let { data } = await htttp.get(HomeData);
    // console.log("STEP: 4 - the data is fetched");
    // console.log(data.data.upcoming[0].description);
    // console.log(data.data.upcoming[0].workshop_ts[4]);

    commit("saveHomeData", data.data);
    // console.log("STEP: 5 -the data is stored in store.HomeData");
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
